import { styled } from "@mui/material";

export const StyledMultiValuesContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.theme.wsc.spacing[0]} 0;
  flex: 1;

  .MuiInputAdornment-root:not(:first-of-type) {
    margin-left: 0;
    margin-right: ${(props) => props.theme.wsc.spacing[0]};
  }
`;

export const StyledContentContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: ${(props) => props.theme.wsc.spacing[1]};
  width: 100%;
`;

export const StyledMoreItems = styled("span")`
  line-height: 1;
  color: #f0f0f0; /* TODO - change to theme color Neutral/100 */
`;

export const StyledShadowContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: ${(props) => props.theme.wsc.spacing[1]};
  visibility: hidden;
  position: absolute;
`;

export const StyledAdornmentContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
